// 상품 내부 이동 경로를 화면에 직접 작성하지 않고 이 상수만 사용한다.
export const QUICK_CASH_ROUTES = Object.freeze({
  entry: '/',
  otp: '/quick-cash-20000/otp',
  otpSuccess: '/quick-cash-20000/otp-success',
  consent: '/quick-cash-20000/consent',
  form: '/quick-cash-20000/form',
  confirm: '/quick-cash-20000/confirm',
  complete: '/quick-cash-20000/complete',
});

export const buildQuickCashEntryUrl = (sessionId = '') => {
  // OTP 재시도 시에도 Quick Cash 진입값과 대기 중인 session_id를 유지한다.
  const params = new URLSearchParams({ open: 'quick-cash-20000' });
  if (sessionId) {
    params.set('session_id', sessionId);
  }
  return `/?${params.toString()}`;
};
